import React, { useEffect, useMemo, useState } from "react";
import { Layout } from "../../components";
import Header from "../../components/Layout/Header";
import {
  Avatar,
  Button,
  Col,
  Divider,
  Input,
  Pagination,
  Row,
  Table,
  Tabs,
  Tag,
  Typography,
} from "antd";
import { FaCheckDouble, FaRegQuestionCircle, FaSearch } from "react-icons/fa";
import useDebounce from "../../config/hooks/useDebounce";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { ApiCaller, Utils } from "../../config";
import { GET_CURRENT_OR_PREVIOUS_USERS } from "../../config/variables";
import { FaUserCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { GamesDetailActions } from "../../store/actions";
import { IoArrowBackCircle } from "react-icons/io5";
import { Actions } from "../../components/atoms/Actions";
import { IoIosInformationCircleOutline, IoIosSend, IoMdCloseCircleOutline } from "react-icons/io";
import { MdCancel, MdOutlineAccessTimeFilled } from "react-icons/md";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack } from "@mui/material";
import { CustomButton } from "../../components/ui/button/CustomButton";
import { set } from "date-fns";
import { use } from "react";

const { TabPane } = Tabs;



const GameDetail = () => {
  let { id } = useParams();
  
  const [dataisGiveawayEligible, setDataisGiveawayEligible] = useState(null);
  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "User Name",
      dataIndex: "fullName",
      key: "fullName",
      width: "35%",
      render: (i, b) => (
        <div>
          {b?.user?.imageUrl ? (
            <Avatar
              size={25}
              src={b?.user?.imageUrl || b?.user?.imageThumbUrl}
              shape="square"
            />
          ) : (
            <Avatar
              icon={<FaUserCircle size={25} className="avatar-style" />}
              shape="square"
            />
          )}{" "}
          <span>{b?.user?.fullName}</span>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (i, b) => (
        <div>
          <span>{b?.user?.email}</span>
        </div>
      ),
    },
    {
      title: generalState?.tabState == "CURRENT" ? (
        <div style={{ textAlign: "right" }}>
          <Button
            type="primary"
            style={{
              backgroundColor: "#55ab3f",
              borderColor: "#55ab3f",
              borderRadius: 5,
            }}
            onClick={() => generateRandomUser(id)}
            disabled={!dataisGiveawayEligible}
          >
            Giveaway
          </Button>
        </div>
      ) : null,
      dataIndex: "giveaway",
      key: "giveaway",
    },
  ];

  const newColumns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "User Name",
      dataIndex: "fullName",
      key: "fullName",
      width: "35%",
      render: (i, b) => (
        <div>
          {b?.user?.imageThumbUrl ? (
            <Avatar
              size={25}
              src={b?.user?.imageUrl || b?.user?.imageThumbUrl}
              shape="square"
            />
          ) : (
            <Avatar
              icon={<FaUserCircle size={25} className="avatar-style" />}
              shape="square"
            />
          )}{" "}
          <span>{b?.user?.fullName}</span>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (i, b) => (
        <div>
          <span>{b?.user?.email}</span>
        </div>
      ),
    },
    {
      title: "Payment Status",
      dataIndex: "paymentstatus",
      key: "paymentstatus",
      render: (i, b) => {        
        return (
          <div>
            {b?.user?.userBankDetail ? (
              <Tag color="green">
                <FaCheckDouble style={{ marginRight: "5px" }} />
                Connected
              </Tag>
            ) : (
              <Tag color="red">
                <FaRegQuestionCircle style={{ marginRight: "5px" }} />
                Not Connected
              </Tag>
            )}
          </div>
        );
      },
    },
    {
        title: "Payment Completed",
        dataIndex: "paymentcompleted",
        key: "paymentcompleted",
        render: (i, b) => { 
          return (
            <div>
              {b?.paymentStatus == "PENDING" ? (
                <div>
                <span>No</span>
              </div>
              ) : (
                <div>
                <span>Yes</span>
              </div>
              )}
            </div>
          );
        },
      },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (i, b) => {
        return (
          <div>
            {true ? (
              <Actions>
                <Actions.Button
                  sx={{ bgcolor: "#f4f0e0", color: "#55ab3f" }}
                  icon={MdOutlineAccessTimeFilled}
                    onClick={() => giveawayUserDetail(b)}
                />
              </Actions>
            ) : (
              <Actions>
                <Actions.Button
                  sx={{ bgcolor: "#f4f0e0", color: "#f2cc2d" }}
                  icon={IoIosSend}
                />
              </Actions>
            )}
          </div>
        );
      },
    },
  ];

  const [generalState, setGeneralState] = useState({
    search: "",
    limit: 10,
    offSet: 0,
    total: 0,
    current: 1,
    tabState: "PREVIOUS",
  });

  const [data, setData] = useState(null);
  const [randomUser, setRandomUser] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [generateRandomUserModal, setGenerateRandomUserModal] = useState(false);
  const [giveawayUserModal, setGiveawayUserModal] = useState(false);
  const [giveawayUserDataModal, setGiveawayUserDataModal] = useState(null);
  const [gameName, setGameName] = useState("");

  const generateRandomUser = async (id) => {
    dispatch(GamesDetailActions.GetGameDetail());
    setRandomUser(null);
    try{
    let res = await ApiCaller.Get(`${GET_CURRENT_OR_PREVIOUS_USERS}${id}/random-giveaway-user`);
    if (res?.data?.status == 200) {
        setRandomUser(res?.data?.data);
        setGenerateRandomUserModal(true);
        dispatch(GamesDetailActions.GetGameDetailSuccess());
        console.log("generateRandomUser", id);
    }
    else{
        dispatch(GamesDetailActions.GetGameDetailFailure());
        Utils.showSnackBar({ message: res.data.error.message, severity: "error" })
      }
    }
    catch (error) {
        console.log(error);
      } finally {
        dispatch(GamesDetailActions.GetGameDetailFailure());
      }
}

const paymentDone = async (myID) => {
    dispatch(GamesDetailActions.GetGameDetail());
    try{
    let res = await ApiCaller.Patch(`${GET_CURRENT_OR_PREVIOUS_USERS}giveaway-payment-status/${myID}`);
    if (res?.data?.status == 200) {
        setGiveawayUserDataModal(null);
        setGiveawayUserModal(false)
        try {
            dispatch(GamesDetailActions.GetGameDetail());
            let res = await ApiCaller.Get(
              `${GET_CURRENT_OR_PREVIOUS_USERS}${id}/list-giveaway-user`
            );

            if (res?.data?.status == 200) {
              setData(res?.data?.data?.rows);
              dispatch(GamesDetailActions.GetGameDetailSuccess());
              setGeneralState((prev) => ({
                ...prev,
                total: res?.data?.data?.count,
              }));
            }
          } catch (error) {
            console.log(error);
            dispatch(GamesDetailActions.GetGameDetailFailure());
          } finally {
            dispatch(GamesDetailActions.GetGameDetailFailure());
          }
    }
    else{
        dispatch(GamesDetailActions.GetGameDetailFailure());
        Utils.showSnackBar({ message: res.data.error.message, severity: "error" })
      }
    }
    catch (error) {
        console.log(error);
      } finally {
        dispatch(GamesDetailActions.GetGameDetailFailure());
      }
}
  

  const confirmRandomUser = async (giveAwayId, userId) => {
    let res = await ApiCaller.Post(`${GET_CURRENT_OR_PREVIOUS_USERS}${giveAwayId}/user/${userId}/confirm-giveaway-user`);
    if (res?.data?.status == 200) {
      try {
        dispatch(GamesDetailActions.GetGameDetail());
        let res = await ApiCaller.Get(
          `${GET_CURRENT_OR_PREVIOUS_USERS}${id}/paid-users?limit=${generalState?.limit}&offset=${generalState?.offSet}&tab=${generalState?.tabState}&search=${generalState?.search}`
        );
        if (res?.data?.status == 200) {
          setData(res?.data?.data?.users?.rows);
          setDataisGiveawayEligible(res?.data?.data?.isGiveawayEligible);
          dispatch(GamesDetailActions.GetGameDetailSuccess());
          setGeneralState((prev) => ({
            ...prev,
            total: res?.data?.data?.users?.count,
          }));
        }
      } catch (error) {
        console.log(error);
        dispatch(GamesDetailActions.GetGameDetailFailure());
      } finally {
        dispatch(GamesDetailActions.GetGameDetailFailure());
      }
        setGenerateRandomUserModal(false);
         Utils.showSnackBar({
                    message: "Giveaway User Confirmed Successfully",
                    severity: "success",
                  });
    }
    else{
        dispatch(GamesDetailActions.GetGameDetailFailure());
        Utils.showSnackBar({ message: res.data.error.message, severity: "error" })
      }
  };

  const giveawayUserDetail = (b) => {
    console.log(b,"ssssss");
    setGiveawayUserDataModal(b);
    setGiveawayUserModal(true)
    
  }

  const dispatch = useDispatch();
  const history = useHistory();

  const { gameName: currentGameName } = useSelector(
    (state) => state?.GameDetailReducer
  );

  // debounce hook
  const debounceValue = useDebounce(generalState.search, 2000);

  useEffect(() => {
    if (id) {
    setData(null);
      const getCurrentOrPreviousUsers = async (id, restValues) => {
        const { limit, offSet, tabState, search } = restValues;
        if (tabState == "GIVEAWAY") {
          console.log("restValues", tabState);
          try {
            dispatch(GamesDetailActions.GetGameDetail());
            let res = await ApiCaller.Get(
              `${GET_CURRENT_OR_PREVIOUS_USERS}${id}/list-giveaway-user`
            );

            if (res?.data?.status == 200) {
              setData(res?.data?.data?.rows);
              dispatch(GamesDetailActions.GetGameDetailSuccess());
              setGeneralState((prev) => ({
                ...prev,
                total: res?.data?.data?.count,
              }));
            }
          } catch (error) {
            console.log(error);
            dispatch(GamesDetailActions.GetGameDetailFailure());
          } finally {
            dispatch(GamesDetailActions.GetGameDetailFailure());
          }
        } else {
          try {
            dispatch(GamesDetailActions.GetGameDetail());
            let res = await ApiCaller.Get(
              `${GET_CURRENT_OR_PREVIOUS_USERS}${id}/paid-users?limit=${limit}&offset=${offSet}&tab=${tabState}&search=${search}`
            );
            if (res?.data?.status == 200) {
              setData(res?.data?.data?.users?.rows);
              setDataisGiveawayEligible(res?.data?.data?.isGiveawayEligible);
              dispatch(GamesDetailActions.GetGameDetailSuccess());
              setGeneralState((prev) => ({
                ...prev,
                total: res?.data?.data?.users?.count,
              }));
            }
          } catch (error) {
            console.log(error);
            dispatch(GamesDetailActions.GetGameDetailFailure());
          } finally {
            dispatch(GamesDetailActions.GetGameDetailFailure());
          }
        }
      };
      getCurrentOrPreviousUsers(id, generalState);
    }
  }, [id, refresh, debounceValue]);

  useEffect(() => {
    if (currentGameName) {
      setGameName(currentGameName);
    }
  }, [gameName]);

  // tabs change handler
  const tabHandler = (key) => {
    setGeneralState((prev) => ({
      ...prev,
      tabState: key,
      current: 1,
      offSet: 0,
    }));
    setRefresh(!refresh);
  };

  // input change handler
  const inputHandler = (value) => {
    setGeneralState((prev) => ({
      ...prev,
      search: value,
      current: 1,
      offSet: 0,
    }));
  };

  // handle pagination
  const handlePagination = (p) => {
    let offSet = (p - 1) * generalState.limit;
    setGeneralState((prev) => ({ ...prev, offSet: offSet, current: p }));
    setRefresh(!refresh);
  };

  const headerProps = useMemo(() => {
    return {
      mainHeading: `${gameName} (Paid User)`,
      subHeading: "",
    };
  }, [gameName]);

  return (
    <div>
      <Layout.DashboardHeader
        // click={this.handleClose}
        columnSpacing={5}
        customizeStyle={{
          display: "flex",
          padding: 25,
          backgroundColor: "#fffcfc",
          marginLeft: 2,
        }}
      >
        <Header
          headings={headerProps}
          icon={
            <IoArrowBackCircle
              className="back-arrow"
              size={24}
              onClick={() => history.push("/games")}
            />
          }
        />

        <div className="game-detail-container">
          <Tabs
            className="winnersTabs paidUsersTabs"
            defaultActiveKey="PREVIOUS"
            onChange={(key) => tabHandler(key)}
          >
            <TabPane tab="Previous Users" key="PREVIOUS" />
            <TabPane tab="Current Prize Pool Users" key="CURRENT" />
            <TabPane tab="Giveaway Users" key="GIVEAWAY" />
          </Tabs>

          <Input
            type="text"
            placeholder="Search"
            className="searchBar games-searchbar"
            size="large"
            value={generalState.search}
            // style={{background: '#'}}
            suffix={<FaSearch className="search-icon-style" />}
            onChange={(e) => {
              inputHandler(e.target.value);
            }}
          />
        </div>
        <div>
          {generalState?.tabState == "PREVIOUS" ? (
            <>
              <Row className="tbl_game">
                <Col span={24}>
                  <Table
                    dataSource={data}
                    columns={columns}
                    pagination={false}
                    className="table-container"
                    loading={false}
                  />
                </Col>
              </Row>
              <Row className="pagination-container">
                <Col span={24}>
                  <Pagination
                    responsive="true"
                    showLessItems="true"
                    defaultCurrent={1}
                    current={generalState?.current}
                    total={generalState?.total}
                    onChange={(p) => {
                      handlePagination(p);
                    }}
                  />
                </Col>
              </Row>
            </>
          ) : generalState?.tabState == "CURRENT" ? (
            <>
              <Row className="tbl_game">
                <Col span={24}>
                  <Table
                    dataSource={data}
                    columns={columns}
                    pagination={false}
                    className="table-container"
                  />
                </Col>
              </Row>
              <Row className="pagination-container">
                <Col span={24}>
                  <Pagination
                    responsive="true"
                    showLessItems="true"
                    defaultCurrent={1}
                    current={generalState?.current}
                    total={generalState?.total}
                    onChange={(p) => {
                      handlePagination(p);
                    }}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row className="tbl_game">
                <Col span={24}>
                  <Table
                    dataSource={data}
                    columns={newColumns}
                    pagination={false}
                    className="table-container"
                  />
                </Col>
              </Row>
              <Row className="pagination-container">
                <Col span={24}>
                  <Pagination
                    responsive="true"
                    showLessItems="true"
                    defaultCurrent={1}
                    current={generalState?.current}
                    total={generalState?.total}
                    onChange={(p) => {
                      handlePagination(p);
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
        </div>

        <Dialog
          open={generateRandomUserModal}
          onClose={() => setGenerateRandomUserModal(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
            ".MuiPaper-root": {
              borderRadius: "10px",
              width: "min(100%, 500px)",
              margin: "1rem",
              py: 2,
            },
          }}
        >
          <DialogTitle id="alert-dialog-title">
            <Stack alignItems="center" spacing={2}>
              {randomUser?.imageThumbUrl ? <Avatar
                shape="circle"
                size={100}
                alt={randomUser?.fullName}
                sx={{ width: 100, height: 100 }}
                src={randomUser?.imageThumbUrl}
              /> : 
              <Avatar
              size={100}
              icon={<FaUserCircle size={100}/>}
              shape="square"
            />}
            </Stack>
          </DialogTitle>
          <IconButton
          aria-label="close"
          onClick={() => {setGenerateRandomUserModal(false); setRandomUser(null)}}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <MdCancel color="#000000" />
        </IconButton>
          <DialogContent>
            <Stack spacing={3} py={1}>
              <Stack spacing={1} sx={{ width: "100%" }}>
                <Row justify="space-around">
                  <Col span={24}>
                    <Typography
                      style={{
                        color: "#435179",
                        fontWeight: 600,
                        fontSize: "16px",
                        flex: 1,
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      {randomUser?.fullName || null}
                    </Typography>
                  </Col>
                </Row>
                <Row justify="space-around">
                  <Col span={24}>
                    <Typography
                      style={{
                        color: "#435179",
                        fontWeight: 600,
                        fontSize: "16px",
                        flex: 1,
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      {randomUser?.email || null}
                    </Typography>
                  </Col>
                </Row>
              </Stack>
            </Stack>
          </DialogContent>
          <DialogActions
            component={Stack}
            direction="row"
            width="100%"
            sx={{ justifyContent: "center", pb: 2, gap: { sm: 1.25, xs: 1 } }}
          >
            <CustomButton
              variant="primary"
              sx={{ flex: 1, maxWidth: "150px" }}
              onClick={() => confirmRandomUser(id, randomUser?.id)}
            >
              Confirm
            </CustomButton>
            <CustomButton
              variant="secondary"
              sx={{
                border: "none",
                borderRadius: "10px",
                flex: 1,
                maxWidth: "150px",
                backgroundColor: "#425078",
                px: 3,
                py: 1.5,
              }}
              onClick={() => generateRandomUser(id)}
            >
              Generate Again
            </CustomButton>
          </DialogActions>
        </Dialog>
        <Dialog
          open={giveawayUserModal}
          onClose={() => setGiveawayUserModal(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
            ".MuiPaper-root": {
              borderRadius: "10px",
              width: "min(100%, 500px)",
              margin: "1rem",
              py: 2,
            },
          }}
        >
          <DialogTitle id="alert-dialog-title">
            <Stack alignItems="center" spacing={2}>
              {giveawayUserDataModal?.user?.imageThumbUrl ? <Avatar
                shape="circle"
                size={100}
                alt={giveawayUserDataModal?.user?.fullName}
                sx={{ width: 100, height: 100 }}
                src={giveawayUserDataModal?.user?.imageThumbUrl || null}
              /> : 
              <Avatar
              size={100}
              icon={<FaUserCircle size={100}/>}
              shape="square" />}
            </Stack>
          </DialogTitle>
          <IconButton
          aria-label="close"
          onClick={() => {setGiveawayUserModal(false); setGiveawayUserDataModal(null)}}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <MdCancel color="#000000" />
        </IconButton>
           <DialogContent>
                    <Stack spacing={4} py={2}>
                      <Stack spacing={1.5} sx={{ width: "100%" }}>
                        <Row justify="space-around">
                          <Col span={12}>
                            <Typography
                              style={{
                                color: "#435179",
                                fontWeight: 600,
                                fontSize: "16px",
                                flex: 1,
                              }}
                            >
                              Bank Name:
                            </Typography>
                          </Col>
                          <Col span={12}>
                            <Typography
                              style={{
                                color: "#000",
                                fontWeight: 600,
                                fontSize: "16px",
                                alignContent: "end",
                                justifyContent: "end",
                                alignItems: "end",
                              }}
                            >
                              {giveawayUserDataModal?.user?.userBankDetail?.bankName || giveawayUserDataModal?.user?.userBankDetail?.bank?.title || 'N/A'}
                            </Typography>
                          </Col>
                        </Row>
                        <Divider />
                        <Row justify="space-around">
                          <Col span={12}>
                            <Typography
                              style={{
                                color: "#435179",
                                fontWeight: 600,
                                fontSize: "16px",
                                flex: 1,
                              }}
                            >
                              Account Title:
                            </Typography>
                          </Col>
                          <Col span={12}>
                            <Typography
                              style={{
                                color: "#000",
                                fontWeight: 600,
                                fontSize: "16px",
                                alignContent: "end",
                                justifyContent: "end",
                                alignItems: "end",
                              }}
                            >
                              {giveawayUserDataModal?.user?.userBankDetail?.accountTitle || 'N/A'}
                            </Typography>
                          </Col>
                        </Row>
                        <Divider />
                        <Row justify="space-around">
                          <Col span={12}>
                            <Typography
                              style={{
                                color: "#435179",
                                fontWeight: 600,
                                fontSize: "16px",
                                flex: 1,
                              }}
                            >
                              Account Number:
                            </Typography>
                          </Col>
                          <Col span={12}>
                            <Typography
                              style={{
                                color: "#000",
                                fontWeight: 600,
                                fontSize: "16px",
                                alignContent: "end",
                                justifyContent: "end",
                                alignItems: "end",
                              }}
                            >
                              {giveawayUserDataModal?.user?.userBankDetail?.accountNumber || 'N/A'}
                            </Typography>
                          </Col>
                        </Row>
                        <Divider />
                        <Row justify="space-around">
                          <Col span={12}>
                            <Typography
                              style={{
                                color: "#435179",
                                fontWeight: 600,
                                fontSize: "16px",
                                flex: 1,
                              }}
                            >
                              Sort Code:
                            </Typography>
                          </Col>
                          <Col span={12}>
                            <Typography
                              style={{
                                color: "#000",
                                fontWeight: 600,
                                fontSize: "16px",
                                alignContent: "end",
                                justifyContent: "end",
                                alignItems: "end",
                              }}
                            >
                              {giveawayUserDataModal?.user?.userBankDetail?.sortCode || 'N/A'}
                            </Typography>
                          </Col>
                        </Row>
                      </Stack>
                    </Stack>
                  </DialogContent>
          <DialogActions
            component={Stack}
            direction="row"
            width="100%"
            sx={{ justifyContent: "center", pb: 2, gap: { sm: 1.25, xs: 1 } }}
          >
            {giveawayUserDataModal?.paymentStatus == "PENDING" && giveawayUserDataModal?.user?.userBankDetail &&(<CustomButton
              variant="primary"
              sx={{ flex: 1, maxWidth: "150px" }}
              onClick={() => paymentDone(giveawayUserDataModal?.id)}
            >
              Mark as Done
            </CustomButton>)}
            {giveawayUserDataModal?.paymentStatus == "PENDING" && giveawayUserDataModal?.user?.userBankDetail &&(<CustomButton
              variant="secondary"
              sx={{
                border: "none",
                borderRadius: "10px",
                flex: 1,
                maxWidth: "150px",
                backgroundColor: "#425078",
                px: 3,
                py: 1.5,
              }}
              onClick={() => {setGiveawayUserModal(false); setGiveawayUserDataModal(null)}}
            >
              Cancel
            </CustomButton>)}
          </DialogActions>
        </Dialog>
      </Layout.DashboardHeader>
    </div>
  );
};

export default GameDetail;
